import { actionType } from "../../helpers/reducers";

export const SEARCH_SET = "search/SET";
export const setSearch = actionType(SEARCH_SET);
